/* global bocAmchart4, am4core, chartLanguage */

/**
 * Default title styles
 */
bocAmchart4.titleStyles = {
    'default': {
        'fontSize': {
            'charttitle': "1em",
            'subtitle': "0.85em"
        },
        'fontWeight': {
            'charttitle': 600
        },
        'paddingBottom': {
            //bocss-padding-small from style guide
            'charttitle': '5px'
        }
    },
    'big': {
        'fontSize': {
            'charttitle': "1.125em",
            'subtitle': "0.85em"
        },
        'fontWeight': {
            'charttitle': 600
        },
        'paddingBottom': {
            //bocss-padding-small from style guide
            'charttitle': '5px'
        }
    },
    'bos': {
        'fontSize': {
            'charttitle': "1em",
            'subtitle': "0.85em"
        },
        'fontWeight': {
            'charttitle': 600
        },
        'paddingBottom': {
            //bocss-padding-small from style guide
            'charttitle': '5px'
        }
    },
    'small': {
        'fontSize': {
            'charttitle': "0.813em",
            'subtitle': "0.75em"
        }
    },
    'homepage_small': {
        'fontSize': {
            'charttitle': "0.813em",
            'subtitle': "0.75em"
        },
        'fontWeight': {
            'charttitle': 600
        },
        'textAlign': {
            'charttitle': "middle",
            'subtitle': "middle"
        },
        'paddingBottom': {
            'charttitle': 0,
            'subtitle': 0
        }
    }
};

/**
 * Sets the titles based on provided shortcode parameters
 * @param {AMConfig} chart chart config json
 * @returns {void}
 */
bocAmchart4.setNotesFromShortcode = function (chart) {
    if (chart.bocSettings.args.hasOwnProperty("note") || chart.bocSettings.args.hasOwnProperty("lastobservation")) {
        var notesId = chart.bocSettings.id + "-notes";
        var notesContainer = am4core.create(notesId, am4core.Container);

        notesContainer.layout = "vertical";
        notesContainer.width = am4core.percent(100);

        bocAmchart4.initChartVars(chart);
        bocAmchart4.vars[chart.bocSettings.id].notesContainer = notesContainer;
        chart.notes = notesContainer;

        if (chart.bocSettings.args.hasOwnProperty("note")) {
            bocAmchart4.addNote(
                notesContainer,
                chart.bocSettings.args.note,
                "main-note",
                "start"
            );
        }

        if (chart.bocSettings.args.hasOwnProperty("lastobservation")) {
            let text = '';
            let forceHtml = false;
            if (chart.bocSettings.args.lastobservation !== "true") {
                text = chart.bocSettings.args.lastobservation;
            } else if (!chart.bocSettings.args.hasOwnProperty('xaxistype') || chart.bocSettings.args.xaxistype === 'date') {
                text += chartLanguage === "fr" ? "Dernière observation : " : "Last observation: ";
                text += "{{series0.date}}";
            } else {
                // eslint-disable-next-line no-console
                console.warn("data-lastObservation=true can only be used with date xAxis and time series.");
            }
            if (chart.bocSettings.args.hasOwnProperty("lastobservationhtml")
                && chart.bocSettings.args.lastobservationhtml === "true") {
                forceHtml = true;
            }

            var suffix = "print-side-note";
            if (chart.bocSettings.args.hasOwnProperty("lastobservationonscreen")
                && chart.bocSettings.args.lastobservationonscreen === "true") {
                suffix = "side-note";
            }

            bocAmchart4.addNote(
                notesContainer,
                text,
                suffix,
                "start",
                forceHtml
            );
        }
    }
};

bocAmchart4.processNotes = function (chart, data) {
    var index = 0;
    var noteObject;
    if (chart.bocSettings.args.hasOwnProperty('note')) {
        // This is being used if defined for screen and in page print
        var noteHTML = bocAmchart4.substituteVariables(chart.bocSettings.args.note, chart, data);
        noteHTML = "<div style=\"" +
            "line-height: 1.4;" +
            "font-size: 13.5;\">" +
            noteHTML + "</div>";
        noteObject = chart.notes.children.getIndex(index++);
        noteObject.html = noteHTML;
        // htmlContent property is used when reverting from page print
        noteObject.htmlContent = noteHTML;

        // This is being used for the exporter menu print / image save, etc.
        noteObject.textContent = bocAmchart4.stripHtml(
            bocAmchart4.substituteVariables(chart.bocSettings.args.note, chart, data)
        );
        noteObject.textContent = bocAmchart4.normalizeLineBreaks(noteObject.textContent);
    }
    if (chart.bocSettings.args.hasOwnProperty('lastobservation')) {
        var text = bocAmchart4.substituteVariables(chart.notes.children.getIndex(index).textContent, chart, data);

        noteObject = chart.notes.children.getIndex(index);
        noteObject.text = text;
        noteObject.textContent = text;
    }
};

/**
 * Process chart titles (both title & subtitle) dynamically.
 * @param {object} chart object
 * @param {string} data chart data
 * @returns {void}
 */
bocAmchart4.processTitles = function (chart, data) {

    /**
     * Internal function to avoid duplication
     * @param {string} property name of property to process
     * @param {int} index of the title
     * @returns {void}
     */
    function processTitle(property, index) {
        const settings = chart.bocSettings.args[property];
        if (!settings) {
            return;
        }

        const processedText = bocAmchart4.substituteVariables(settings, chart, data);
        bocAmchart4.updateTitleHelper(chart, processedText, index);
    }

    let index = 0;
    ['charttitle', 'subtitle'].forEach(prop => {
        if (chart.bocSettings.args.hasOwnProperty(prop)) {
            processTitle(prop, index++);
        }
    });
};

/**
 * Sets the titles based on provided shortcode parameters
 * @param {am4core.Container} container chart config json
 * @param {string} text for the label
 * @param {string} id for the label
 * @param {string} textAlign position of the note {start, middle, end}
 * @param {bool} forceHTML whether to force using html for last observation text
 * @returns {void}
 */
bocAmchart4.addNote = function (container, text, id, textAlign, forceHTML) {
    var htmlFreeText = bocAmchart4.stripHtml(text);
    htmlFreeText = bocAmchart4.normalizeLineBreaks(htmlFreeText);

    var noteItem = {
        'text': htmlFreeText,
        'textContent': htmlFreeText,
        'wrap': true,
        'textAlign': textAlign,
        'width': am4core.percent(100),
        'fontSize': "0.844em",
        'opacity': 0.75,
        'id': id
    };

    if (id === "main-note" || forceHTML) {
        noteItem.html = "<div style=\"" +
            "line-height: 1.4;" +
            "font-size: \"0.844em\";\">" +
            text + "</div>";
        noteItem.htmlContent = noteItem.html;
    }
    var note = container.createChild(am4core.Label);
    for (var property in noteItem) {
        if (noteItem.hasOwnProperty(property)) {
            note[property] = noteItem[property];
        }
    }
};

/**
 * Update chart title for the chart
 * @param {object} chart object
 * @param {string} text string
 * @returns {void}
 */
bocAmchart4.updateChartTitle = function (chart, text) {
    bocAmchart4.updateTitleHelper(chart, text, 0);
};

/**
 * Update chart subtitle for the chart
 * @param {object} chart object
 * @param {string} text string
 * @returns {void}
 */
bocAmchart4.updateChartSubTitle = function (chart, text) {
    bocAmchart4.updateTitleHelper(chart, text, 1);
};

/**
 * Helper function to update a chart title or subtitle.
 * @param {object} chart Chart object.
 * @param {string} text New title/subtitle text.
 * @param {number} index 0 for title, 1 for subtitle.
 * @returns {void}
 */
bocAmchart4.updateTitleHelper = function (chart, text, index) {
    const titlesContainer = bocAmchart4.vars[chart.bocSettings.id].titlesContainer;
    if (!titlesContainer.children.hasIndex(index)) {
        return;
    }

    const titleObject = titlesContainer.children.getIndex(index);
    const htmlFreeText = bocAmchart4.stripHtml(text);
    titleObject.textContent = bocAmchart4.normalizeLineBreaks(htmlFreeText);
    titleObject.text = titleObject.textContent;

    if (htmlFreeText !== text) {
        const lineHeight = index === 0 ? "1.15em" : "1.1em";
        const htmlContent = `<div style="line-height:${lineHeight}; padding:0px 0px 1px 0px;">${text}</div>`;
        titleObject.html = htmlContent;
        titleObject.htmlContent = htmlContent;
    } else {
        titleObject.html = titleObject.htmlContent = null;
    }

    titlesContainer.invalidate();
};

/**
 * Sets the titles based on provided shortcode parameters
 * @param {AMConfig} chart chart config json
 * @returns {void}
 */
bocAmchart4.setTitlesFromShortcode = function (chart) {

    var titlesId = chart.bocSettings.id + "-titles";
    var titlesContainer = am4core.create(titlesId, am4core.Container);

    titlesContainer.layout = "vertical";
    titlesContainer.width = am4core.percent(100);

    bocAmchart4.initChartVars(chart);
    bocAmchart4.vars[chart.bocSettings.id].titlesContainer = titlesContainer;
    chart.title = titlesContainer;

    //Sets default title style unless otherwise set
    if (!chart.bocSettings.args.hasOwnProperty("titlestyle")) {
        chart.bocSettings.args.titlestyle = 'default';
    }

    var titles = ['charttitle', 'subtitle'];
    titles.forEach(function (title) {
        if (chart.bocSettings.args.hasOwnProperty(title)) {
            if (bocAmchart4.debug(chart)) {
                // eslint-disable-next-line no-console
                console.log(
                    chart.bocSettings.id,
                    "Adding " + title + " from shortcode",
                    ":",
                    chart.bocSettings.args[title]
                );
            }
            bocAmchart4.addChartTitle(chart, title, chart.bocSettings.args[title]);
        }
    });
};

/**
 * Adds specific title to the chart
 * @param {AMConfig} chart chart config json
 * @param {string} titleType charttitle/subtitle
 * @param {string} text actual text for the title
 * @returns {void}
 */
bocAmchart4.addChartTitle = function (chart, titleType, text) {
    var htmlFreeText = bocAmchart4.stripHtml(text, true);
    var thisTitleStyle = chart.bocSettings.args.titlestyle || 'default';
    var properties = {};
    var property;

    // Get the corresponding styles for the specified titlestyle
    if (bocAmchart4.titleStyles.hasOwnProperty(thisTitleStyle)) {
        properties = bocAmchart4.titleStyles[thisTitleStyle];
    }

    // Check for additional custom title styles defined in chart.bocSettings
    if (typeof chart.bocSettings.titleStyles === 'object') {
        if (chart.bocSettings.titleStyles.hasOwnProperty(thisTitleStyle)) {
            for (property in chart.bocSettings.titleStyles[thisTitleStyle]) {
                if (chart.bocSettings.titleStyles[thisTitleStyle].hasOwnProperty(property)) {
                    properties[property] = chart.bocSettings.titleStyles[thisTitleStyle][property];
                }
            }
        }
    }

    // Remove shortcodes in the text (replace them with empty strings for now)
    var shortcodes = /{{series(\d+)\.(date|value)}}/g;
    let textNoPlaceholders = text.replace(shortcodes, '');
    textNoPlaceholders = bocAmchart4.normalizeLineBreaks(textNoPlaceholders);


    // Define the default properties for the title or subtitle
    var titlesItem = {
        'text': htmlFreeText,
        'textContent': htmlFreeText,
        'wrap': true,
        'textAlign': "start",
        'width': am4core.percent(100),
        'paddingBottom': 10,
        'paddingTop': 10
    };

    if (htmlFreeText !== text) {
        titlesItem.html = "<div style=\"line-height:1.15em; left: 0; right: 0; padding: 0px 1px 1px 0px; " +
            "margin-top: -1.5px\">" + textNoPlaceholders + "</div>";
        titlesItem.htmlContent = titlesItem.html;
    }

    // Apply the appropriate styles for chart title or subtitle
    for (property in properties) {
        if (properties.hasOwnProperty(property) && properties[property].hasOwnProperty(titleType)) {
            titlesItem[property] = properties[property][titleType];
        }
    }

    // Get the titles container where the titles will be added
    var titlesContainer = bocAmchart4.vars[chart.bocSettings.id].titlesContainer;

    // Create a new label for the title or subtitle and apply the properties
    var title = titlesContainer.createChild(am4core.Label);
    for (property in titlesItem) {
        if (titlesItem.hasOwnProperty(property)) {
            title[property] = titlesItem[property];
        }
    }
};


/**
 * Processes any text to replace all the placeholders with actual last modified date and last value
 *
 * @param {string} textWithVars String containing the original placeholders, such as {series0.date}
 * @param {object} chart AMChart object
 * @param {array} data passed to the chart
 * @returns {string} Processed string
 */
bocAmchart4.substituteVariables = function (textWithVars, chart, data) {
    var dateReg = /{{series(\d+)\.date}}/g;
    var series = [];
    var dateVar;
    var dates = [];
    // eslint-disable-next-line no-cond-assign
    while (dateVar = dateReg.exec(textWithVars)) {
        dates.push(dateVar);
        if (series.indexOf(dateVar[1]) === -1) {
            series.push(dateVar[1]);
        }
    }

    var valueReg = /{{series(\d+)\.value}}/g;
    var valueVar;
    var values = [];
    // eslint-disable-next-line no-cond-assign
    while (valueVar = valueReg.exec(textWithVars)) {
        values.push(valueVar);
        if (series.indexOf(valueVar[1]) === -1) {
            series.push(valueVar[1]);
        }
    }

    // If there's no shortcodes used - return without any changes
    if (series === []) {
        return;
    }

    var seriesNames = [];
    var fieldsCount = 0;
    series.forEach(function (index) {
        if (typeof chart.series.values[index] !== 'undefined'
            && chart.series.values[index].dataFields.hasOwnProperty('valueY')) {
            seriesNames.push({
                'index': index,
                'name': chart.series.values[index].dataFields.valueY
            });
            fieldsCount++;
        }
    });

    for (var index = data.length; index > 0 && fieldsCount > 0; index--) {
        seriesNames.forEach(function (seriesName) {
            if (seriesName.hasOwnProperty("value")) {
                return;
            }
            // Grab the last data point
            var dataPoint = data[index - 1];

            if (dataPoint.hasOwnProperty(seriesName.name)) {
                seriesName.value = dataPoint[seriesName.name];
                var axis = chart.xAxes.getIndex(0);
                // Update date format for 'Last Observation' if the period the time unit is 'month'
                let dateFormat;
                if (chart.bocSettings.args.period === 'month') {
                    dateFormat = "MMMM yyyy";
                } else {
                    dateFormat = axis.dateFormats.getKey(axis.baseInterval.timeUnit);
                }

                if (axis.hasOwnProperty('dateFormats')) {
                    seriesName.date = chart.dateFormatter.format(
                        dataPoint['date'],
                        dateFormat
                    );
                    seriesName.date = seriesName.date.replace(/^1(?=\s)/, "1[baseline-shift: super; font-size: 10;]er[/]");
                } else {
                    seriesName.date = dataPoint['date'];
                    // eslint-disable-next-line no-console
                    console.warn(
                        "Automatic last observation available only for date type x axis, please use manual override."
                    );
                }
                fieldsCount--;
            }
        });
    }

    seriesNames.forEach(function (seriesName) {
        dates.forEach(function (date) {
            if (date[1] === seriesName.index) {
                let seriesNameDate = seriesName.date;
                if (chartLanguage === 'fr' && chart.bocSettings.args.period !== 'quarter') {
                    seriesNameDate = seriesNameDate.toLowerCase();
                }
                textWithVars = textWithVars.replace(date[0], seriesNameDate);
            }
        });
    });

    seriesNames.forEach(function (seriesName) {
        values.forEach(function (value) {
            if (value[1] === seriesName.index) {
                textWithVars = textWithVars.replace(value[0], seriesName.value);
            }
        });
    });

    return textWithVars;
};


/**
 * Strips HTML out of provided text
 * @param {string} text The text to be stripped of html
 * @param {boolean} maintainFormatting If true, will try to maintain basic formatting of certain html elements (line breaks etc.)
 * @return {string} String stripped of html
 */
bocAmchart4.stripHtml = function (text, maintainFormatting = true) {
    var cleanedText = text;

    if (maintainFormatting) {
        cleanedText = cleanedText
            //Turns <br> element into new line character
            .replace(/<br>/gm, '\n');
    }

    cleanedText = cleanedText
        //Removes everything within < > braces to effectively remove any html from the string
        .replace(/<[^>]*>?/gm, "");

    return cleanedText;
};

/**
 * Make all the linebreaks linux style
 * @param {string} text Input string
 * @return {string} String with standard linebreaks
 */
bocAmchart4.normalizeLineBreaks = function (text) {
    return text
        //Replaces all occurrences of 2+ empty spaces with a single new line character
        .replace(/(\r\n|\n|\r){2,}/gm, "\n");
};
